import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { QuotaAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Date Cell Renderer
 *
 * Renders date values using the FormatDateHour pipe (dd-MM-yyyy HH:mm:ss)
 *
 * @example
 * ```typescript
 * {
 *   field: 'date',
 *   headerName: 'Fecha',
 *   cellRenderer: DateCellRendererComponent,
 *   minWidth: 180
 * }
 * ```
 */
@Component({
  selector: 'app-date-cell-renderer',
  standalone: true,
  imports: [CommonModule, FormatOtherDateHourPipe],
  template: `
    {{ params.value | FormatDateHour: true }}
  `,
})
export class DateCellRendererComponent implements CellRenderer<QuotaAttributes, Date | string> {
  @Input() params!: CellRendererParams<QuotaAttributes, Date | string>;
}
